<mat-toolbar class="grid-container" color="primary">	
	<div class="item item1">
		<img class="borda-logo" *ngIf="(this.cliente.getClienteFilial !== undefined)"
			src="{{logoEmpresa}}" (click)="getRouterLink()" >
	</div>
	<div *ngIf="logoMini">
		<img class="borda-logo logo-imagem-mini" src="assets/images/logo_mini.png"(click)="getRouterLink()">
	</div>	
	<div class="item item3" *ngIf="isCliente && pesquisaVisivel && temAcesso">
		<app-search-bar #searchbar (idsPesquisaEmitter)="emitIdsPesquisa($event)"
			(isLoadingEmitter)="emitIsLoading($event)" (ocultaAbasEmitter)="emitOcultarAbas($event)" [consultaDetalhada]="consultaDetalhada"
			[qtdFiltros]="qtdFiltros" (openDialog)="openDialogPesquisaDetalhada()" [aplicarFiltros]="aplicarFiltros">
		</app-search-bar>
	</div>
	<div [ngClass]="(temAcesso) ? 'item4':'item5'" class="item">
		<app-menu [nomeUsuario]="nomeUsuario" [isCliente]="isCliente"></app-menu>
	</div>
	<div *ngIf="utilizaMural" class="item item5 notification-container">
		<mat-icon [matBadge]="mensagensNaoLidas" 
				[matBadgeHidden]="mensagensNaoLidas === 0"  
				matBadgeColor="warn" 
				matBadgePosition="above after" 
				matBadgeSize="medium"
				(click)="abrirNotificacoes()">notifications</mat-icon>
	</div>
	<div class="item item6" *ngIf="isCliente && temAcesso">
		<app-carrinho-menu #cartmenu></app-carrinho-menu>
	</div>
</mat-toolbar>
<a [href]="'https://wa.me/'+whatsapp" target="_blank" *ngIf="temWhatsapp">
	<img src="assets/images/whatsapp.png" class="icone-whatsapp">
</a>